import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Button,
  Spinner,
  Alert,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import { APIClient } from "../../helpers/api_helper";
import BreadCrumb from "../../components/Common/BreadCrumb";
import { translateApiError } from "../../helpers/translateApiError";

const api = new APIClient();

const SystemTools = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const handleUpdateDeliveryStatus = async () => {
    setLoading(true);
    setResult(null);
    setError(null);

    try {
      const response = await api.create(
        `${process.env.REACT_APP_API_BASE_URL}/admin/delivery-status/update`,
        {}
      );

      if (response?.data) {
        setResult(response.data);
      } else {
        setResult(response);
      }
    } catch (err) {
      console.error("Error updating delivery status:", err);
      setError(
        translateApiError(err, t("systemTools.deliveryStatus.failed"))
      );
    } finally {
      setLoading(false);
    }
  };

  document.title = t("common.pageTitle", { page: t("systemTools.pageTitle") });

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title={t("systemTools.pageTitle")}
          pageTitle={t("systemTools.breadcrumbParent")}
        />

        <Row>
          <Col lg={6}>
            <Card>
              <CardHeader>
                <h5 className="card-title mb-0">
                  <i className="ri-refresh-line me-2"></i>
                  {t("systemTools.deliveryStatus.title")}
                </h5>
              </CardHeader>
              <CardBody>
                <p className="text-muted mb-3">
                  {t("systemTools.deliveryStatus.description")}
                </p>
                
                <Button
                  color="primary"
                  onClick={handleUpdateDeliveryStatus}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <Spinner size="sm" className="me-2" />
                      {t("common.processing")}
                    </>
                  ) : (
                    <>
                      <i className="ri-refresh-line me-2"></i>
                      {t("systemTools.deliveryStatus.button")}
                    </>
                  )}
                </Button>

                {error && (
                  <Alert color="danger" className="mt-3">
                    <i className="ri-error-warning-line me-2"></i>
                    {error}
                  </Alert>
                )}

                {result && (
                  <Alert color="success" className="mt-3">
                    <h6 className="alert-heading">
                      <i className="ri-check-line me-2"></i>
                      {t("systemTools.deliveryStatus.complete")}
                    </h6>
                    <hr />
                    <div className="mb-0">
                      <Row>
                        <Col xs={6} md={4}>
                          <strong>{t("systemTools.deliveryStatus.processed")}</strong>{" "}
                          {result.processed}
                        </Col>
                        <Col xs={6} md={4}>
                          <strong>{t("systemTools.deliveryStatus.delivered")}</strong>{" "}
                          <span className="text-success">{result.delivered}</span>
                        </Col>
                        <Col xs={6} md={4}>
                          <strong>{t("systemTools.deliveryStatus.failedCount")}</strong>{" "}
                          <span className="text-danger">{result.failed}</span>
                        </Col>
                        <Col xs={6} md={4}>
                          <strong>{t("systemTools.deliveryStatus.pending")}</strong>{" "}
                          <span className="text-warning">{result.pending}</span>
                        </Col>
                        <Col xs={6} md={4}>
                          <strong>{t("systemTools.deliveryStatus.unknown")}</strong>{" "}
                          <span className="text-muted">{result.unknown}</span>
                        </Col>
                      </Row>
                    </div>
                  </Alert>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SystemTools;
